import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=c2550312&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/chat.css?vue&type=style&index=0&id=c2550312&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2550312",
  null
  
)

export default component.exports